
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"#fff","viewBox":"0 0 256 256"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M128 24a104 104 0 10104 104A104.11 104.11 0 00128 24zm0 192a88 88 0 1188-88 88.1 88.1 0 01-88 88zm16-40a8 8 0 01-8 8 16 16 0 01-16-16v-40a8 8 0 010-16 16 16 0 0116 16v40a8 8 0 018 8zm-32-92a12 12 0 1112 12 12 12 0 01-12-12z"}})])
          )
        }
      }
    